import { render, staticRenderFns } from "./DispatchSummaryHeader.vue?vue&type=template&id=e43f00bc&scoped=true"
import script from "./DispatchSummaryHeader.vue?vue&type=script&lang=js"
export * from "./DispatchSummaryHeader.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummaryHeader.vue?vue&type=style&index=0&id=e43f00bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43f00bc",
  null
  
)

export default component.exports